import { render, staticRenderFns } from "./SidenavBlock.vue?vue&type=template&id=14632193&"
import script from "./SidenavBlock.vue?vue&type=script&lang=js&"
export * from "./SidenavBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../suport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports